<template>
  <div
    :class="[
      'hab-left-filter-time-of-day',
      {
        active: active,
      },
    ]"
    v-on:click="onClick"
  >
    <p class="text-13-500 mb-4">{{ dataSource.name }}</p>
    <span>{{ dataSource.time[0] }} - {{ dataSource.time[1] }}</span>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onChange"],
  methods: {
    onClick() {
      this.$emit("onChange", this.dataSource);
    },
  },
};
</script>
